import { render, staticRenderFns } from "./RejectionBOMTable.vue?vue&type=template&id=673508b2&"
import script from "./RejectionBOMTable.vue?vue&type=script&lang=js&"
export * from "./RejectionBOMTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports